import { createContext, useContext } from "react";

import { defaultFeatureFlagsContext } from "@/contexts/featureFlags/constants";

import { type FeatureFlagsContextType } from "./types";

const FeatureFlagsContext = createContext<FeatureFlagsContextType>(
  defaultFeatureFlagsContext,
);

export const FeatureFlagsContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <FeatureFlagsContext.Provider value={defaultFeatureFlagsContext}>
    {children}
  </FeatureFlagsContext.Provider>
);

// eslint-disable-next-line react-refresh/only-export-components
export const useFeatureFlags = (): FeatureFlagsContextType =>
  useContext(FeatureFlagsContext);
